@if (logs$ | async; as logs) {
  <div class="log-viewer-container">
<pre #logViewer>
<code>@for (log of logs; track log) {<span>{{ log }}</span>
}
</code>
</pre>
  </div>
} @else {
  <tp-spinner/>
}
